/* ==========================================================================
   Price > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'Price',
    css: {
        component: 'price-pak',
        hidden: 'is-hidden'
    }
};

/* Exports */
module.exports = () => config;
